var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ListSelect',{attrs:{"aria-required":"true","options":_vm.options,"placeholder":_vm.placeholder,"id":_vm.id,"name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }